import { TextField, dividerClasses } from "@mui/material";
import { Formik } from "formik";
import React, { useEffect, useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import RegularButton from "../../components/Buttons/RegularButton";
import { useLoginSendOtpMutation } from "../../redux/services/authApi";
import * as Yup from "yup";
import MuiAlert from "../../pages/MuiAlert/MuiAlert";
import Loader from "../../pages/commons/Loading";

type Props = {};

type Values = {
    mobileNumber: string;
};

const SigninSchema = Yup.object().shape({
    mobileNumber: Yup.string().required('Mobile number is required').min(10, 'Mobile number must be 10 digits only').max(10, 'Mobile number must be 10 digits only'),
});

const SignIn = ({ }: Props) => {

    const navigate = useNavigate();
    const [isAlertVisible, setIsAlertVisible] = useState(false);
    const [statusCode, setStatusCode] = useState({ type: "", code: "" }) as any;
    const [loginUser, loginUserResponse] = useLoginSendOtpMutation();
    const [data, setData]: any = useState();

    const loginWithEmailAndPassword = (
        mobileNumber: string,
    ) => {
        loginUser({
            phoneNo: mobileNumber,
            category: 'UTCUST',
            emailFlag: false,
        });
    };
    const handleLogin = (
        values: Values,
    ) => {
        setData(values.mobileNumber);
        loginWithEmailAndPassword(values.mobileNumber);
    };


    

    useEffect(() => {
        if (loginUserResponse.isSuccess) {
            navigate("/profile/auth/OtpAcceptPage", { state: { ssoLogindata: data,Mobile:true } })
            
            setStatusCode({
                type: "success",
                code: "NUMBER_SENT_SUCCESS"
            })
            setIsAlertVisible(true)
            setTimeout(() => {
                setIsAlertVisible(false)
            }, 5000)

        }

        if (loginUserResponse.isError) {
            let newMassege: any = loginUserResponse.error;
            let finaleMsg = newMassege?.data && newMassege?.data?.serviceErrors && newMassege?.data?.serviceErrors[0];
            if (finaleMsg?.errorCode == "411") {
                setStatusCode({
                    type: "error",
                    code: "NUMBER_SENT_FAILURE"
                })
                setIsAlertVisible(true)
                setTimeout(() => {
                    setIsAlertVisible(false)
                }, 5000)

            }
            else {
                setStatusCode({
                    type: "error",
                    code: "CONSENT_FORM_ERROR"
                })
                setIsAlertVisible(true)
                setTimeout(() => {
                    setIsAlertVisible(false)
                }, 5000)
            }
        }
    }, [
        loginUserResponse.isSuccess, loginUserResponse.isError,
    ]);

    return (
        <div>
            {loginUserResponse.isLoading  ? (
                <Loader />
            ) : null}
            <div className="">
                <div className="w-[90%] flex lg:hidden  m-2 ">
                    <NavLink to={"/"}>
                        <img
                            src={require("../../assets/logo.png")}
                            alt=""
                            className="md:w-[50px] w-[40px]"
                        />
                    </NavLink>
                </div>

                <div className="md:mx-[10px] mx-[4px]">
                    <div
                        className=" w-full  p-3 flex items-center lg:hidden  md:flex-col"
                        style={{
                            background: `rgb(226 55 68) center center no-repeat`,
                            backgroundSize: "cover",
                        }}
                    >
                        <div className="  flex justify-center flex-col">
                            <img
                                src={require("../../assets/slide3.png")}
                                className="w-full"
                                alt=""
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div className="flex flex-row ">
                <div className=" h-[100%] mt-[10px]  lg:w-1/2 w-full  md:px-10 justify-center ">
                    <div className="mt-[35px] lg:flex hidden">
                        <NavLink to={"/"}>
                            <img
                                src={require("../../assets/logo.png")}
                                alt=""
                                className="w-[50px]"
                            />
                        </NavLink>
                    </div>

                    <div className="md:flex md:items-center lg:mt-[50px] md:mt-0 mt-[10px] justify-center flex-col flex items-center">
                        {isAlertVisible && (
                            <div>
                                <MuiAlert
                                    severity={statusCode?.type!}
                                    messageType={statusCode?.code!}
                                />
                            </div>
                        )}

                        <div className="md:m-[3.4rem]   m-0">
                            <h1 className="md:text-[32px] text-[22px] mt-[30px] text-[#475467]  font-bold">
                                Login
                            </h1>
                            <Formik
                                enableReinitialize
                                initialValues={{
                                    mobileNumber: "",
                                }}
                                validationSchema={SigninSchema}
                                onSubmit={handleLogin}
                            >
                                {({
                                    handleBlur,
                                    handleChange,
                                    handleSubmit,
                                    values,
                                    touched,
                                    errors,
                                }) => (
                                    <div className="w-[85%] md:w-[400px] ">
                                        <div className="mt-7">
                                            <TextField
                                                variant="outlined"
                                                label="Mobile Number"
                                                color='error'
                                                size="small"
                                                autoFocus={true}
                                                inputProps={{ maxLength: 10 }}
                                                type="text"
                                                onChange={handleChange('mobileNumber')}
                                                onBlur={handleBlur('mobileNumber')}
                                                value={values.mobileNumber}
                                                placeholder={'Enter mobile number'}


                                                className="appearance-none rounded w-full p-2 text-gray-700 leading-tight focus:outline-none focus:shadow-outline border-b font-bold"
                                            />
                                            <div className="text-red-500 text-sm">
                                                {errors.mobileNumber}
                                            </div>
                                        </div>
                                        <div className="lg:flex sm:flex-row items-center gap-5 mt-5 ">
                                            <RegularButton
                                                onClick={() => {
                                            
                                                    handleSubmit();

                                                }}
                                                className="w-[100%] md:w-[400px]"
                                                title={"Get OTP"}
                                            />
                                        </div>
                                    </div>
                                )}
                            </Formik>
                            <p className="flex justify-center mb-0 gap-2 text-red-500 mr-4  py-6 cursor-default">

                                <span
                                    className="text-red-500 cursor-pointer underline justify-center"
                                    onClick={() => {
                                        navigate("/profile/auth/Login");
                                    }}
                                >
                                    Or Login with Email?
                                </span>
                            </p>

                        </div>
                    </div>
                    <p className="text-[#8A8A8A]  mt-[65%] sm:mt-[20%] ml-[5%] sm:ml-[5%] lg:mt-[64%] ">
                        © 2024 CarRental. All Rights Reserved
                    </p>
                </div>
                <div
                    className=" w-1/2 hidden p-[58px] 2xl:h-[100vh] lg:flex lg:items-center  lg:flex-col"
                    style={{
                        background: `rgb(226 55 68) center center no-repeat`,
                        backgroundSize: "cover",
                    }}
                >
                    <div className=" flex lg:h-[100%] xl:h-[768px] mt-2 2xl:h-[100%] justify-center">
                        <img
                            src={require("../../assets/auth1.png")}
                            className="w-[700px] 2xl:w-[1000px] mb-[10px] md:mb-0"
                            alt=""
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SignIn;
